"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupItem = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireDefault(require("react"));

var _coreDecorators = require("core-decorators");

var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));

var _styles = _interopRequireDefault(require("./styles"));

var _class;

var GroupItem = (_class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(GroupItem, _React$PureComponent);

  function GroupItem() {
    (0, _classCallCheck2.default)(this, GroupItem);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GroupItem).apply(this, arguments));
  }

  (0, _createClass2.default)(GroupItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          title = _this$props.title,
          count = _this$props.count,
          selected = _this$props.selected;
      var disabled = count === 0;
      return _react.default.createElement("div", {
        className: _styles.default.root,
        role: "presentation",
        onClick: !disabled ? this.clickHandler : undefined
      }, _react.default.createElement("div", {
        className: _styles.default.checkbox,
        role: "presentation",
        onClick: stubHandler
      }, _react.default.createElement(_Checkbox.default, {
        checked: selected,
        disabled: disabled,
        onChange: this.checkboxChangeHandler
      })), _react.default.createElement("div", {
        className: _styles.default.title(theme, disabled)
      }, title), count !== undefined ? _react.default.createElement("div", {
        className: _styles.default.count(theme, disabled)
      }, count) : '');
    }
  }, {
    key: "clickHandler",
    value: function clickHandler() {
      this.props.onClick(this.props.id);
    }
  }, {
    key: "checkboxChangeHandler",
    value: function checkboxChangeHandler() {
      this.props.onClick(this.props.id);
    }
  }]);
  return GroupItem;
}(_react.default.PureComponent), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "clickHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "clickHandler"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "checkboxChangeHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "checkboxChangeHandler"), _class.prototype)), _class);
exports.GroupItem = GroupItem;

function stubHandler(event) {
  event.stopPropagation();
}